import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AccessDenied = () => {
    return (_jsxs("div", { style: { textAlign: 'center', marginTop: '80px' }, children: [_jsx("h2", { style: { marginBottom: '20px' }, children: "Toegang Geweigerd" }), _jsx("p", { children: "U heeft geen toegangsrechten." }), _jsxs("p", { style: { marginTop: '20px' }, children: ["Ga terug naar ", _jsx("a", { href: '/admin/WorkordersList', children: "de startpagina" }), "."] })] }));
};
export default AccessDenied;
